import React from 'react';
import { contentRoot, heading, text } from '../DarkBrowserInvalid/styles';

function MaintenancePage() {
  return (
    <div className={contentRoot}>
      <h1 className={heading}>
        We are currently upgrading our systems, we will be back in a few hours.
      </h1>
      <p className={text}>Apologies for the inconvenience</p>
    </div>
  );
}

export default MaintenancePage;
